import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Keep a deep link (e.g. /?tab=invoices&invoice=…) through sign-in, then hand it back once.
export const rememberNext = () => { if (window.location.search.includes("tab=")) sessionStorage.setItem("cj_next", window.location.pathname + window.location.search); };
export const takeNext = () => { const p = sessionStorage.getItem("cj_next"); sessionStorage.removeItem("cj_next"); return p && p.startsWith("/") ? p : "/"; };
